
import React from "react";
import { Trash2 } from "lucide-react";
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle 
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Recebimento {
  id: string;
  descricao: string;
  valor: number;
  dataVencimento?: Date;
  dataPagamento?: Date;
  cliente: string;
  status: string;
}

interface RecebimentoDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recebimento: Recebimento | null;
  onConfirm: () => void;
}

const RecebimentoDeleteDialog: React.FC<RecebimentoDeleteDialogProps> = ({
  open,
  onOpenChange,
  recebimento,
  onConfirm
}) => {
  if (!recebimento) return null;
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Confirmar Exclusão</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir o recebimento de {recebimento.descricao} no valor de {recebimento.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-gray-500">
            Esta ação não pode ser desfeita.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button variant="destructive" onClick={onConfirm}>
            <Trash2 className="h-4 w-4 mr-2" /> Confirmar Exclusão
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RecebimentoDeleteDialog;
